import { useNavigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import React, { useEffect, useState, useCallback } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import Grid from "@mui/material/Grid";
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { CustomNavigationClient } from "./utils/NavigationClient";
import Footer from "./ui-components/Footer";
import { PageLayout } from "./ui-components/PageLayout";

// Page Imports
import HomePage from './pages/home';
import GloriaMrio from "./pages/GloriaMrio";
import ContactUs from "./pages/ContactUs";
import Metadata from './pages/Metadata';
import Footprint from './pages/footprint';
import Guidelines from './pages/Guidelines';
import { Profile } from "./pages/Profile";
import { Logout } from "./pages/Logout";
import { ProfileWithMsal } from "./pages/ProfileWithMsal";
import { ProfileRawContext } from "./pages/ProfileRawContext";
import { ProfileUseMsalAuthenticationHook } from "./pages/ProfileUseMsalAuthenticationHook";

function App({ pca }) {
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    const { instance } = useMsal(); // MSAL instance to manage authentication
    const isAuthenticated = useIsAuthenticated(); // Use MSAL hook to check authentication status
    const [activeAccount, setActiveAccount] = useState(null);

    useEffect(() => {
        const accounts = instance.getAllAccounts();
        console.log("Accounts on load:", accounts);

        if (accounts.length > 0) {           
            setActiveAccount(accounts[0]); // Set the first account as the active one
        } else {           
            setActiveAccount(null);
        }
    }, [instance]);

    // Idle Timer State
    const [idleState, setIdleState] = useState({
        status: 'Active',
        actionCount: 0,
        remainingTime: 0
    });

    // Function to log the user out
    const handleLogout = useCallback((method) => {
        console.log("User is idle. Logging out...");
        navigate("/logout");
    }, [navigate]);

    const onIdle = useCallback(() => {
        setIdleState(prev => {
            console.log("Idle Timer Status:", prev.status); // Log current idle status
            return { ...prev, status: 'Idle' };
        });
    
        console.log("isAuthenticated:", isAuthenticated); // Log authentication status
    
        // Check if user is authenticated and idle state is "Idle"
        if (isAuthenticated) {
            handleLogout("popup"); // Call logout when idle time is reached and user is authenticated
        }
    }, [handleLogout, isAuthenticated]); // Dependency on isAuthenticated to ensure it's up-to-date

    const onActive = useCallback(() => setIdleState(prev => ({ ...prev, status: 'Active' })), []);
    const onAction = useCallback(() => setIdleState(prev => ({ ...prev, actionCount: prev.actionCount + 1 })), []);

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        onActive,
        onAction,
        timeout: 600_000,  // 10 minutes
        throttle: 500
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setIdleState(prev => ({
                ...prev,
                remainingTime: Math.ceil(getRemainingTime() / 1000)
            }));
        }, 500);

        return () => clearInterval(interval);
    }, [getRemainingTime]);


    return (
        <MsalProvider instance={pca}>
            <PageLayout>
                <Grid container justifyContent="center">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/gloria-mrio" element={<GloriaMrio />} />
                        <Route path="/metadata" element={<Metadata />} />
                        <Route path="/Guidelines" element={<Guidelines />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                        <Route path="/calculator" element={<Footprint />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/profileWithMsal" element={<ProfileWithMsal />} />
                        <Route path="/profileRawContext" element={<ProfileRawContext />} />
                        <Route path="/profileUseMsalAuthenticationHook" element={<ProfileUseMsalAuthenticationHook />} />
                        <Route path="/logout" element={<Logout />} />
                    </Routes>
                </Grid>
                <Footer />

                {/* Idle Timer UI 
                {isAuthenticated && (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <h2>React Idle Timer</h2>
                        <p>Current State: {idleState.status}</p>
                        <p>Action Events: {idleState.actionCount}</p>
                        <p>{idleState.remainingTime} seconds remaining</p>
                    </div>
                )}*/}
            </PageLayout>
        </MsalProvider>
    );
}

export default App;